import { createAction, props } from '@ngrx/store';
import { IMEIValidateAPIResultItem } from '@sky/util-models';

export const loadImei = createAction(
  '[Basket] Load IMEI',
  props<{ imei: string }>()
);

export const loadImeiSuccess = createAction(
  '[Basket] IMEI loaded successfully',
  props<{ imeiApiResult: IMEIValidateAPIResultItem }>()
);

export const loadImeiFailure = createAction(
  '[Basket] Load IMEI failed',
  props<{ error: Error }>()
);

export const resetImei = createAction('[Basket] Reset IMEI');
